import React       from 'react';
import NumberLayer from 'pu-react/components/NumberLayer';
import { numberLayerFlex } from '../../data/SelectOptions';

const Component = (props) => {
  if (!props.show) { return null; }
  return (
    <NumberLayer
      {...props}
      options={numberLayerFlex}
      label="# of Flex Layers"
      name="number_of_flex_layers" />
  );
};

Component.defaultProps = {
  show: true,
};

export default Component;
